// extracted by mini-css-extract-plugin
export default {"bestsellers":"BestSellers_bestsellers__ahkOi"};